module.exports = __webpack_public_path__ + "img/20210828_213920.efd3fa5b.jpg";